import {GET_USER_INFO} from '../../shared/constants/ActionTypes';

const initialState = {
  user: {},
};

const userInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_INFO:
      return {
        ...state,
        usersList: action.payload,
      };

    default:
      return state;
  }
};
export default userInfoReducer;
